import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SatelliteMachineView } from "./SatelliteMachineView";
import { SatelliteMachineViewStore } from "../../store/SatelliteMachineViewStore";
import { useStore } from "../../../../hooks";

export const SatelliteMachineViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/satelliteMachine/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SatelliteMachineViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "identity",
              label: rootStore.langStore.groupSatelliteMachineIdentityLabel,
            },
            {
              id: "certificate",
              label: rootStore.langStore.groupSatelliteMachineCertificateLabel,
            },
            {
              id: "authentication",
              label:
                rootStore.langStore.groupSatelliteMachineAuthenticationLabel,
            },
            {
              id: "authorization",
              label:
                rootStore.langStore.groupSatelliteMachineAuthorizationLabel,
            },
            {
              id: "capabilities",
              label: rootStore.langStore.groupSatelliteMachineCapabilitiesLabel,
            },
            {
              id: "network",
              label: rootStore.langStore.groupSatelliteMachineNetworkLabel,
            },
            {
              id: "monitoring",
              label: rootStore.langStore.groupSatelliteMachineMonitoringLabel,
            },
            {
              id: "relations",
              label: rootStore.langStore.groupSatelliteMachineRelationsLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SatelliteMachineView satelliteMachineViewStore={store} />
      </PageLayout>
    </div>
  );
});
